import { useEffect, useState } from 'react';

/** File/Blob 미리보기 URL을 생성하고 교체·unmount 시 해제한다. */
export const useObjectUrl = (source?: Blob | null): string => {
  const [objectUrl, setObjectUrl] = useState('');

  useEffect(() => {
    if (!source) {
      setObjectUrl('');
      return;
    }

    const nextObjectUrl = URL.createObjectURL(source);
    setObjectUrl(nextObjectUrl);

    return () => URL.revokeObjectURL(nextObjectUrl);
  }, [source]);

  return objectUrl;
};
